export function normalizePayments<TPayment>(
  payments: Array<TPayment> | null | undefined,
): Array<TPayment> {
  return Array.isArray(payments) ? payments : [];
}

type PaymentItem<TPayments> =
  TPayments extends Array<infer TPayment> ? TPayment : never;

type NormalizedPaymentRow<TRow extends { payments?: Array<unknown> | null }> =
  Omit<TRow, 'payments'> & {
    payments: Array<PaymentItem<NonNullable<TRow['payments']>>>;
  };

export function normalizePaymentRows<
  TRow extends { payments?: Array<unknown> | null },
>(rows: Array<TRow> | null | undefined): Array<NormalizedPaymentRow<TRow>> {
  return (rows ?? []).map((row) => ({
    ...row,
    payments: normalizePayments<
      PaymentItem<NonNullable<TRow['payments']>>
    >(row.payments),
  }));
}
